import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useApi } from "@/lib/api";

const MeCtx = createContext({ me: null, loading: true, refresh: () => {} });
export const useMe = () => useContext(MeCtx);

export function MeProvider({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!isSignedIn) { setMe(null); setLoading(false); return; }
    try { setMe(await api("get", "/me")); } catch { setMe(null); } finally { setLoading(false); }
  }, [isSignedIn, api]);

  useEffect(() => { if (isLoaded) { setLoading(true); refresh(); } }, [isLoaded, refresh]);

  return <MeCtx.Provider value={{ me, loading: !isLoaded || loading, refresh }}>{children}</MeCtx.Provider>;
}
